import React from "react";
import Loader from "../../../../components/Loader";
import ModalAdmin from "../../../../components/ModalAdmin";
import { SuccessContent, ConfirmContent, ErrorContent } from "./ModalContent";

interface ModalProps {
  isOpen: boolean;
  onRequestClose?: () => void;
  closeModal?: () => void;
  onAlterPhone?: () => void;
  onConfirmPhone?: () => void;
  smallWidth?: boolean;
  status: string;
  phoneString: string;
  loading: number;
}

export const ModalConfirmPhone: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  closeModal,
  status,
  phoneString,
  onAlterPhone,
  onConfirmPhone,
  loading,
}) => {
  var headerLabel = "";
  if (status !== "confirm") {
    headerLabel = "Confirmação";
  } else {
    headerLabel = "Verificação de celular";
  }

  return (
    <ModalAdmin
      isOpen={isOpen}
      headerLabel={headerLabel}
      onRequestClose={onRequestClose}
      closeModal={closeModal}
    >
      <Loader loading={loading} />
      {status === "confirm" && (
        <ConfirmContent
          phoneString={phoneString}
          onAlterPhone={onAlterPhone}
          onConfirmPhone={onConfirmPhone}
        />
      )}

      {status === "error" && (
        <ErrorContent phoneString={phoneString} onOkClick={closeModal} />
      )}

      {status === "success" && (
        <SuccessContent phoneString={phoneString} onOkClick={closeModal} />
      )}
    </ModalAdmin>
  );
};
